import React from "react";
import { NavLink } from "react-router-dom";
import {
  FaFacebookF,
  FaTelegramPlane,
  FaTwitter,
  FaSnapchatGhost,
} from "react-icons/fa";

export default function FooterSection() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-section">
      <div className="footer_container">
        <div className="footer_nav_links">
          <h3>Navigations</h3>
          <NavLink to={"/home"} className={"footer_link"}>Home</NavLink>
          <NavLink to={"/about"} className={"footer_link"}>About</NavLink>
          <NavLink to={"/plan"} className={"footer_link"}>Plans</NavLink>
          <NavLink to={"/contact"} className={"footer_link"}>Contact</NavLink>
          <NavLink to={"/login"} className={"footer_link"}>Login</NavLink>
          <NavLink to={"/signup"} className={"footer_link"}>Sign up</NavLink>
        </div>

        <div className="important_links">
          <h3>Important links</h3>
          <NavLink to={"/plans"} className={"footer_link"}>Pricing plan</NavLink>
          <NavLink to={"/predictions/expert"} className={"footer_link"}>Bet of the day</NavLink>
          <NavLink to={"/predictions/freebet"} className={"footer_link"}>Today free Bet</NavLink>
          <NavLink to={"/faqs"} className={"footer_link"}>FAQ</NavLink>
          <NavLink to={"/terms"} className={"footer_link"}>Terms and conditions</NavLink>
        </div>


        <div className="contact_links">
          <h3>Contact Us</h3>
          <NavLink to={"tel:233200664766"} className={"footer_link"}>233 200 6647 66</NavLink>
          <NavLink to={"mailto:info@payoutprophet.com"} className={"footer_link"}>
            info@payoutprophet.com
          </NavLink>

          <div className="social_links">
            <NavLink className={"social_link"}>
              <FaFacebookF />
            </NavLink>

            <NavLink className={"social_link"}>
              <FaTelegramPlane />
            </NavLink>

            <NavLink className={"social_link"}>
              <FaTwitter />
            </NavLink>

            <NavLink className={"social_link"}>
              <FaSnapchatGhost />
            </NavLink>
          </div>
        </div>
      </div>
        <hr />


      <div className="payment_methods">
        <img src="/payment_method_images/mtn.jpg" alt="mtn momo" className="p_method" />
        <img src="/payment_method_images/telecel.jpg" alt="telecel cash" className="p_method" />
        <img src="/payment_method_images/visa.jpg" alt="visa" className="p_method" />
        <img src="/payment_method_images/mastercard.jpg" alt="mastercard" className="p_method" />
        <img src="/payment_method_images/btc.jpg" alt="mtn momo" className="p_method" />
      </div>

        <hr />
      <p>Payout Prophet @ {year}. All right reserved.</p>
    </footer>
  );
}
